// React Imports
import { Fragment, ReactElement, useEffect, useState } from "react";

// Third Party Libraries Imports
import ReactQuill from "react-quill";
import { Button, Form, FormInstance } from "antd";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";

// Local Imports
import BreadcrumbComponent from "../../components/breadcrumb-component/breadcrumb-component";
import Label from "../../components/label/label.component";
import CustomInput from "../../components/custom-input/custom-input.component";

const AddEditEmailTemplate: React.FC = (): ReactElement => {
  // eslint-disable-next-line no-restricted-globals
  const queryParams = new URLSearchParams(location.search);
  const [form]: [FormInstance<any>] = Form.useForm();
  const edit: string | null = queryParams.get("edit");
  const values: any = Form.useWatch([], form);
  const [submitLoginForm, setSubmitLoginForm] = useState<boolean>(false);

  useEffect(() => {
    form.validateFields({ validateOnly: true }).then(
      () => {
        setSubmitLoginForm(true);
      },
      () => {
        setSubmitLoginForm(false);
      }
    );
  }, [values]);

  return (
    <section className="flex flex-col">
      <BreadcrumbComponent />

      <div className="flex flex-col py-[2%] bg-white rounded-[20px]">
        <h3 className=" text-xl border-b-[1px] border-black-200 px-[2%] pb-4">
          {edit ? "Edit Email Template" : "Create an email template"}
        </h3>
        {
          <Form form={form} className="p-[2%]">
            <div className="flex-wrap flex justify-between">
              <div className="flex flex-col w-full md:w-[49%]">
                <Label text="Key" />
                <Form.Item
                  name="nameEn"
                  rules={[
                    {
                      required: true,
                      message: "Please input Key!",
                    },
                  ]}
                >
                  <CustomInput placeholder="Enter Key" />
                </Form.Item>
              </div>
              <div className="flex flex-col w-full md:w-[49%]">
                <Label text="Tempalte name" />
                <Form.Item
                  name="nameAr"
                  rules={[
                    {
                      required: true,
                      message: "Please input Tempalte name!",
                    },
                  ]}
                >
                  <CustomInput placeholder="Enter Tempalte name" />
                </Form.Item>
              </div>
              <div className="flex flex-col w-full md:w-[49%]">
                <Label text="Subject" />
                <Form.Item
                  name="minimumAmount"
                  rules={[
                    {
                      required: true,
                      message: "Please input Subject!",
                    },
                  ]}
                >
                  <CustomInput placeholder="Enter Subject" />
                </Form.Item>
              </div>
              <div className="flex flex-col justify-between w-full">
                <Form.List
                  name="strategies"
                  initialValue={[
                    {
                      nameEn: "",
                    },
                  ]}
                  rules={[
                    {
                      validator: async (_, names) => {
                        if (!names) {
                          return Promise.reject(
                            new Error("At least 1 variable")
                          );
                        }
                      },
                    },
                  ]}
                >
                  {(fields: any = 1, { add, remove }, { errors }) => (
                    <Form.Item>
                      <div className="flex flex-col justify-between flex-wrap">
                        <div className="flex justify-between flex-wrap">
                          {fields.map((field: any, index: any) => (
                            <Fragment key={index}>
                              <div className="flex flex-col flex-wrap justify-between w-full md:w-[49%]">
                                <div className="flex flex-col ">
                                  <Label text={"Variable"} />
                                  <Form.Item
                                    {...field}
                                    name={[field.name, `Variable${index}`]}
                                    validateTrigger={["onChange", "onBlur"]}
                                    rules={[
                                      {
                                        required: true,
                                        whitespace: true,
                                        message: "Please input Variable",
                                      },
                                    ]}
                                  >
                                    <CustomInput placeholder="Enter Variable Name" />
                                  </Form.Item>
                                </div>
                                {fields.length > 1 ? (
                                  <Button
                                    className="flex items-center w-full justify-end text-red-600 border-0 bg-transparent mb-2 shadow-none p-0"
                                    onClick={() => remove(field.name)}
                                  >
                                    <MinusCircleOutlined />
                                    Delete
                                  </Button>
                                ) : null}
                              </div>
                            </Fragment>
                          ))}
                        </div>
                        <Form.Item>
                          <div className="add-field-button flex justify-start w-full">
                            <Button
                              onClick={() => add()}
                              className=" border-0 text-blue-500 bg-transparent mb-2 shadow-none p-0 text-base"
                              icon={<PlusOutlined />}
                            >
                              Add variable
                            </Button>
                          </div>
                          <Form.ErrorList errors={errors} />
                        </Form.Item>
                      </div>
                    </Form.Item>
                  )}
                </Form.List>
              </div>
              <div className="flex flex-col w-full">
                <Label text="Template Data" />
                <Form.Item
                  name="termsAndConditionsEn"
                  rules={[
                    {
                      required: true,
                      message: "Please input Template Data",
                    },
                  ]}
                >
                  <ReactQuill className=" min-h-64" theme="snow" />
                </Form.Item>
              </div>
            </div>

            <div className="flex w-full flex-wrap items-center justify-between mt-7 border-t-[1px] border-gray-900 pt-5">
              <div className="flex w-[28%] md:w-[48%]">
                <a className=" cursor-pointer underline text-gray-700">Reset</a>
              </div>
              <div className="flex justify-between items-center w-[70%] md:w-[48%]">
                <button
                  type="button"
                  className="rounded-lg bg-white w-[48%] py-3 text-center outline-0 cursor-pointer text-xs md:text-sm font-semibold border-[1px] border-blue-500 text-blue-500"
                >
                  Cancel
                </button>
                <button
                  className="rounded-lg bg-blue-500 w-[48%] py-3 text-center outline-0 cursor-pointer text-xs md:text-sm font-semibold border-[1px] border-blue-500 text-white"
                  type="button"
                  disabled={!submitLoginForm}
                >
                  {edit ? "Update bank" : "Create bank"}
                </button>
              </div>
            </div>
          </Form>
        }
      </div>
    </section>
  );
};

export default AddEditEmailTemplate;
